import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Result, Button } from 'antd';
import { useLocation, useParams, useRouteMatch } from 'react-router-dom';
import adminRouteConfig from '../../adminRouteConfig';
import Navigation from './Navigation';
import './style.scss';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

export default Dashboard = props => {
    let content = props.children;

    return (
        <Layout>
            <Content className="adaya-admin-dashboard">
                Click a section on the left.
            </Content>
        </Layout>
    );

};